import React from "react";
import { v4 as uuidv4 } from "uuid";
import Button from "@mui/material/Button";
import cloud from "../../assets/db_images/cloud-data.png";
import legacy from "../../assets/db_images/legacy.png";
import cross from "../../assets/db_images/cross-platform.png";

const Services = () => {
  let featureList = [
    {
      id: uuidv4(),
      title: "Cloud-Based Database Migration",
      image: cloud,
      description:
        "Seamlessly transition your data to the cloud with our expert database migration services. We ensure a smooth and secure transfer of your existing databases to cloud platforms, optimizing performance and unlocking the scalability and flexibility of cloud computing.",
    },
    {
      id: uuidv4(),
      title: "Legacy System Upgradation & Modernization",
      image: legacy,
      description:
        " Upgrade and modernize your legacy database systems to keep pace with evolving technologies. Our services focus on enhancing performance, improving security, and incorporating the latest features to future-proof your databases, ensuring they remain agile and efficient.",
    },
    {
      id: uuidv4(),
      title: "Cross-Platform Database Migration",
      image: cross,
      description:
        " Enable your data to flow effortlessly across different platforms with our cross-platform migration services. Whether you're moving from one database management system to another or transitioning between on-premises and cloud environments, we facilitate a seamless migration process, minimizing downtime and ensuring data integrity.",
    },
  ];

  return (
    <div id="solutions">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
        Services we Provide
      </p>
      <div className="flex justify-evenly px-3 sm:px-20 mt-10 gap-3 flex-col sm:flex-row">
        {featureList.map((item) => (
          <div
            key={item.id}
            class="w-full bg-gradient-to-l from-slate-300 to-slate-100 text-slate-600 border border-slate-300 grid grid-col-2 justify-center p-4 gap-4 rounded-lg shadow-md"
          >
            <div class="col-span-2 text-lg font-bold capitalize rounded-md text-[#00756a] italic">
              {item.title}
            </div>
            <div class="col-span-2 rounded-md">{item.description}</div>
            <div>
              <Button variant="outlined" href="#contact">
                Let's Connect
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
